import { render, staticRenderFns } from "./contentCourseAccessibility.vue?vue&type=template&id=6233e4da&"
import script from "./contentCourseAccessibility.vue?vue&type=script&lang=js&"
export * from "./contentCourseAccessibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports